function titleCase(str: string) {
  return str.replace(/^./, str[0]?.toUpperCase());
}

/**
 * Formats a label string by capitalizing words and optionally uppercasing specified acronyms.
 * @param {string} label - The input label string to format.
 * @param {string[]} [uppercaseAcronyms] - An array of acronyms to force to uppercase in the result.
 * @param {boolean} [capitalizeAll] - If true, capitalize every word; otherwise, only the first word.
 * @returns {string} The formatted label string.
 * @example
 * formatLabel('premium label'); // "Premium label"
 * formatLabel('user id', ['ID']); // "User ID"
 * formatLabel('premium label', [], true); // "Premium Label"
 */
export function formatLabel(
  label: string,
  uppercaseAcronyms: string[] = [],
  capitalizeAll?: boolean
) {
  const prefix = capitalizeAll
    ? label
        .split(' ')
        .map((s) => titleCase(s))
        .join(' ')
        .split('_')
        .map((s) => titleCase(s))
        .join(' ')
    : titleCase(label.split('_').join(' ').toLowerCase());
  return prefix
    .split(' ')
    .map((s) =>
      uppercaseAcronyms.map((a) => a.toUpperCase()).includes(s.toUpperCase())
        ? s
            .split('')
            .map((p) => p.toUpperCase())
            .join('')
        : s
    )
    .join(' ');
}
